<template>
    <path d="M12.0007 10.586L16.9507 5.63599L18.3647 7.04999L13.4147 12L18.3647 16.95L16.9507 18.364L12.0007 13.414L7.05072 18.364L5.63672 16.95L10.5867 12L5.63672 7.04999L7.05072 5.63599L12.0007 10.586Z" fill="#333335" fill-opacity="0.5"/>
</template>

<script>
    export default {
        name: 'icon-cross'
    }
</script>